import React from "react"
import { doc, setDoc, collection, updateDoc } from "firebase/firestore"
import { db } from "../firebase"

function ChatHeader({ question, id }) {
  const endConsultation = async () => {
    const docRef = doc(db, "questions", id)
    await setDoc(
      docRef,
      {
        status: false,
      },
      {
        merge: true,
      }
    ).then(() => console.log("Document updated"))
    const chatRef = doc(db, "chats", id)
    await setDoc(
      chatRef,
      {
        status: false,
      },
      { merge: true }
    )
  }

  return (
    <header className="header sticky top-0 bg-white shadow-md flex items-center justify-between px-8 py-02">
      <div className="box-content h-20 w-6/12 overflow-auto">
        {question.desc}
      </div>

      <nav className="nav font-semibold text-lg">
        <div className="flex items-center">
          <div className="p-4 border-b-2 border-green-500 border-opacity-0 hover:border-opacity-100 hover:text-green-500 duration-200 cursor-pointer active">
            {question.doctor === "mdmazumdar17@gmail.com"
              ? "Dr Madhumita Mazumdar"
              : question.doctor}
          </div>
        </div>
      </nav>
      {question.doctor === "mdmazumdar17@gmail.com" ? (
        <div className="w-1/12 flex justify-end">
          <button
            className="border-2 border-blue-500 rounded-full font-bold text-blue-500 px-2 py-1 transition duration-300 ease-in-out hover:bg-blue-500 hover:text-white mx-auto cursor-pointer"
            onClick={() => {
              endConsultation()
            }}
          >
            End Consultation
          </button>
        </div>
      ) : null}
    </header>
  )
}

export default ChatHeader
